import Select from '../components/Select';

export default class StaticBlog {
  constructor(section) {
    this.el = section.el;
    this.initializedClass = 'blog-initialized';
    this._validate();
  }

  onSectionLoad() {
    this._validate();
  }

  onSectionUnload() {
    window.removeEventListener('resize', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });

    const filterSelect = this.el.querySelector('.blog-tag-filter select');

    if (filterSelect) {
      filterSelect.removeEventListener('change', event => this.filterBlog(event));
    }
  }

  _validate() {
    if (window.innerWidth <= 1080) {
      this.positionSidebar('below');
    } else {
      this.positionSidebar();
    }

    this.setupFeaturedImage();
    this.setupFullWidthImages();

    window.addEventListener('resize', () => {
      this.setupFullWidthImages();
      if (window.innerWidth <= 1080) {
        this.positionSidebar('below');
      } else {
        this.positionSidebar();
        this.setupFeaturedImage();
      }
    });

    const filterSelect = this.el.querySelector('.blog-tag-filter select');

    if (filterSelect) {
      new Select({ el: filterSelect });

      filterSelect.addEventListener('change', event => this.filterBlog(event));
    }
  }

  filterBlog(e) {
    if (!this.el.querySelector('[data-tag-filter]')) {
      return;
    }

    const { tag, dataset } = e.target;
    const { url } = dataset;

    window.location.href = tag === 'all'
      ? `/blogs/${url}`
      : `/blogs/${url}/tagged/${tag}`;
  }

  setupFeaturedImage() {
    const posts = this.el.querySelectorAll('.blog-post');

    posts.forEach(post => {
      const image = post.querySelector('img.highlight');

      if (image) {
        image.addEventListener('rimg:load', () => {
          post.querySelector('.blog-post-inner').style.paddingTop = `${image.getBoundingClientRect().height - 60}px`;
        });
      }
    });
  }

  setupFullWidthImages() {
    const postContent = this.el.querySelector('.post-content');
    const postContentWidth = postContent.getBoundingClientRect().width;
    const postContentMargin = postContent.style.marginLeft;

    this.el.querySelectorAll('img.full-width').forEach(image => {
      image.style.width = `${postContentWidth}px`;
      image.style.left = `-${postContentMargin}px`;
    });
  }

  positionSidebar(position) {
    const wrapper = this.el.querySelector('.blog-posts');
    const sidebar = this.el.querySelector('.blog-sidebar');

    if (position === 'below') {
      wrapper.parentNode.insertBefore(sidebar, wrapper.nextSibling);
    } else {
      wrapper.parentNode.insertBefore(sidebar, wrapper);
    }
  }
}
